import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { Button, Col, Row, Spinner, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import moment from "moment";
// import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router-dom";
import Confirm from "../Confirm";
//   import TaskView from "./TaskView";
import Permissionhelper from "../common/Permissionhelper";
import * as constants from "../../constants/CONSTANT";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import { formatDate } from "../../utils/helper";
import HandoverEdit from "./HandoverEdit";
import HandoverView from "./HandoverView";
import { ROUTES } from "../../constants/webRouting";

const RelatedListHandover = ({ parentid, refreshHandoverList, table }) => {
  const [modalShow, setModalShow] = React.useState(false);
  const [handover, setHandover] = React.useState("");
  const [modalShowHandover, setModalShowHandover] = React.useState(false);
  const [modalShowHandoverView, setModalShowHandoverView] =
    React.useState(false);
  const [isFollowUp, setModalShowFollowUp] = React.useState(false);

  // Create table headers consisting of 4 columns.

  const [body, setBody] = useState([]);

  useEffect(() => {
    handoverList();
  }, [refreshHandoverList]);

  const handoverList = () => {
    async function init() {
      let hanoverRecords = await fuziElevatorsApi.fetchHandoverByParentId(parentid);
      if (hanoverRecords && hanoverRecords?.length > 0) {
        setBody(hanoverRecords);
      } else {
        setBody([]);
      }
    }
    init();
  };
  const handleDelete = (row) => {
    setModalShow(true);
    setHandover(row);
  };

  const labels = {
    beforeSelect: " ",
  };

  const deleteHandover = async () => {
    const result = await fuziElevatorsApi.deleteHandoverRecordById(handover?.id); //deleteHandoverRecords
    if (result.success) {
      setHandover("");
      setModalShow(false);
      handoverList();
    }
  };

  const submitHandover = () => {
    setModalShowHandover(false);
    handoverList();
  };

  const editHandover = (row) => {
    setModalShowHandover(true);
    setHandover(row);
  };

  const viewHandover = (row) => {
    setModalShowHandoverView(true);
    setHandover(row);
  };

  const Handoverheader = [
    {
      title: "Offer Name",
      prop: "offer_name_label",
      isFilterable: true,
      cell: (row) => (
        <Link to={`${ROUTES.HANDOVER.LIST}/${row.id}`} state={row}>
          {row.offer_name_label}
        </Link>
      ),
    },
    { title: "Pincode", prop: "pincode", isFilterable: true },
    { title: "City", prop: "city", isFilterable: true },
    { title: 'Handover Date', prop: "handover_date", cell: (row) => (row.handover_date ? formatDate(row.handover_date) : ''), isFilterable: true },
    {
      title: "Actions",
      prop: "id",
      cell: (row) => (
        <>
          {/* <Button className="btn-sm mx-2" onClick={() => editHandover({ row })}>
            <i className="fa-regular fa-pen-to-square"></i>
          </Button> */}
          {Permissionhelper.checkPermission(constants.SUPER_ADMIN) && (
            <Button
              className="btn-sm mx-2"
              variant="danger"
              onClick={() => handleDelete(row)}
            >
              <i className="fa-regular fa-trash-can"></i>
            </Button>
          )}
        </>
      ),
    },
  ];

  const headers = Handoverheader;
  return (
    <>
      {modalShow && (
        <Confirm
          show={modalShow}
          onHide={() => setModalShow(false)}
          deleteHandover={deleteHandover}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="handover"
        />
      )}
      {modalShowHandover && (
        <HandoverEdit
          show={modalShowHandover}
          onHide={() => setModalShowHandover(false)}
          // parentid={lead?.id}
          table="order"
          handover={handover}
          submitHandover={submitHandover}
        />
      )}

      {modalShowHandoverView && (
        <HandoverView
          show={modalShowHandoverView}
          onHide={() => setModalShowHandoverView(false)}
          //parentid={parent.id}
          //task={task}
          handover={handover}
          submitHandover={submitHandover}
        />
      )}

      {body ? (
        <DatatableWrapper
          body={body}
          headers={headers}
          paginationOptionsProps={{
            initialState: {
              rowsPerPage: 5,
            },
          }}
        >
          <Row className="mb-4">
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-start align-items-start"
            ></Col>
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-start align-items-start"
            ></Col>
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-end align-items-end"
            ></Col>
          </Row>
          <Table
            striped
            className="related-list-table shadow rounded sm "
            responsive={true}
          >
            <TableHeader classes={{ th: "bg-custom text-white" }} />
            {body && Array.isArray(body) ? (
              <TableBody />
            ) : (
              <tbody className="">
                <tr>
                  <td colSpan={100} align="center">
                    <div>
                      <Spinner />
                    </div>
                  </td>
                </tr>
              </tbody>
            )}
          </Table>
          <Pagination
            classes={{
              buttonGroup: "btn-custom",
              button: "bg-custom border-white",
            }}
          />
          {/*  //Added by shivani */}
        </DatatableWrapper>
      ) : (
        ""
      )}
    </>
  );
};

export default RelatedListHandover;
